import * as Yup from "yup";

export const productValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(2, "Name must be at least 2 characters long"),
  description: Yup.string().nullable(),
  cost_price: Yup.number()
    .required("Cost price is required")
    .positive("Cost price is required"),
  selling_price: Yup.number()
    .required("Selling price is required")
    .positive("Selling price is required")
    .moreThan(
      Yup.ref("cost_price"),
      "Selling price must be greater than cost price"
    ),
  sku: Yup.string().min(3, "SKU must be at least 3 characters long"),
  barcode: Yup.string()
    .nullable()
    .min(5, "Barcode must be at least 5 characters long"),
  allow_taxes: Yup.boolean().required(),
  weight: Yup.number().nullable().min(0, "Weight must be a positive number"),
  weight_unit: Yup.string()
    .nullable()
    .oneOf(["kg", "g", "lb"], "Weight unit must be one of kg, g, lb"),
  quantity: Yup.number()
    .required("Quantity is required")
    .positive("Quantity is required"),
  reorder_quantity: Yup.number()
    .nullable()
    .min(0, "Reorder quantity cannot be negative"),
  category_id: Yup.number()
    .required("Category is required")
    .positive("Category is required"),
  branch_id: Yup.number()
    .required("Branch is required")
    .positive("Branch is required"),
  supplier_id: Yup.number()
    .required("Supplier ID is required")
    .positive("Supplier is required"),
  sell_oos: Yup.boolean(),
  expiry_date: Yup.date().nullable().notRequired(),
  files: Yup.array()
    .of(Yup.string().required("File is required")) // Assuming files are Base64 strings
    .nullable(),
});
